import React, {useContext, useEffect, useRef, useState} from 'react';
import {APIProvider, useMapsLibrary} from '@vis.gl/react-google-maps';
import {Editable, EditableProps} from "./Editable";
import {PlaceAutocomplete} from "./PlaceAutocomplete";
import {EditableContext, useEditable} from "./EditableContext";


type Props<EnclosingType extends object> = EditableProps<EnclosingType, any> & {
  // Awkward that get and set are different.
  getter: (entity: EnclosingType) => string | null | undefined,
  setter: (entity: EnclosingType, value: google.maps.places.PlaceResult) => EnclosingType,
}

export const EditableAddressField = <EnclosingType extends object>(props: Props<EnclosingType>) => {

  const API_KEY = ("AIzaSyCFJhMw3rXpVRXvhxjFTmELaqdHigbQ2nw");

  const [placeAutocomplete, setPlaceAutocomplete] =
      useState<google.maps.places.Autocomplete | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const places = useMapsLibrary('places');

  const {editing, mode, workingCopy, setWorkingCopy} = useContext(EditableContext);
  
  useEffect(() => {
    if (!places || !inputRef.current) return;
    const options = {
      fields: ['geometry', 'name', 'formatted_address']
    };
    setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
  }, [places]);

  useEffect(() => {
    if (!placeAutocomplete) {
      return;
    }

    placeAutocomplete.addListener('place_changed', () => {
      setWorkingCopy(props.setter(workingCopy, placeAutocomplete.getPlace()))
    });

  }, [placeAutocomplete]);

  if (mode == 'create' || (mode == 'update' && editing && !props.immutable)) {
    return <Editable {...props}>
      <APIProvider apiKey={API_KEY} solutionChannel=''>
        <PlaceAutocomplete onPlaceSelect={v => v && setWorkingCopy(props.setter(workingCopy, v))}
                           defaultValue={props.getter(workingCopy) ?? ''}
                           className={'EditableEditing'}/>
      </APIProvider>
    </Editable>;
  }

  return <Editable {...props}>
    <div className={'EditableNotEditing'}>{props.getter(workingCopy) || ''}
    </div>
  </Editable>
}

